import { useEffect, useState } from "react";
import { BranchCapacitiesDto } from "api/product";
import { productsAPI } from "services/swagger-api";

/* What the branch registry of the back declares for each branch, as the product
   form needs it. `null` while loading (or if loading failed): callers must not
   draw conclusions about a branch until the list is there. */
export const useBranchesCapacites = (): BranchCapacitiesDto[] | null => {
  const [capacites, setCapacites] = useState<BranchCapacitiesDto[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    productsAPI.getBranchesCapacites()
      .then(response => {
        if (!cancelled) {
          setCapacites(response);
        }
      })
      .catch(error => {
        console.error("Erreur lors du chargement des capacités des branches:", error);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return capacites;
};
